/**
 * OneRealm - Entry point
 */

import { Game } from './Game';

// Create game container
const container = document.getElementById('app');

if (!container) {
  throw new Error('Could not find #app container');
}

// Create game instance
const game = new Game(container);

// Show main menu for faction and difficulty selection
game.showMainMenu();

// Expose game to window for debugging
(window as unknown as { game: Game }).game = game;

// Handle visibility change to pause/resume
document.addEventListener('visibilitychange', () => {
  if (document.hidden) {
    game.pause();
  } else {
    game.resume();
  }
});
